export default defineNuxtPlugin(nuxtApp => {
	const payload = nuxtApp.payload as typeof nuxtApp.payload & {
		deviceType?: "mobile" | "desktop";
		isMobile?: boolean;
	};
	let deviceType: "mobile" | "desktop" = "desktop";

	// 服务端检测（SSR）
	if (!import.meta.client) {
		const event = useRequestEvent();
		const contextDeviceType = event?.context?.deviceType;
		if (contextDeviceType === "mobile" || contextDeviceType === "desktop") {
			deviceType = contextDeviceType;
		} else {
			const userAgent = event?.node.req.headers["user-agent"] || "";
			deviceType = /Mobile|Android|iPhone/i.test(userAgent) ? "mobile" : "desktop";
		}

		payload.deviceType = deviceType;
		payload.isMobile = deviceType === "mobile";

		// 在服务端设置设备类型到HTML根元素
		useHead({
			htmlAttrs: {
				"data-device": deviceType,
			},
		});
	}
	// 客户端检测
	else {
		deviceType = payload.deviceType === "mobile" ? "mobile" : "desktop";

		// 在客户端也设置设备类型到HTML根元素（确保一致性）
		if (typeof document !== "undefined") {
			document.documentElement.setAttribute("data-device", deviceType);
		}
	}

	// 提供给全局使用
	nuxtApp.provide("deviceType", deviceType);
	nuxtApp.provide("isMobile", deviceType === "mobile");
});
